import {P2} from '@/componentLibrary/components/typography';
import {ColorFgSubtle} from '@/componentLibrary/tokens/variables';

export const EmptyState = ({notParagraph = false}) => (
    <P2 forwardedAs={notParagraph ? 'span' : 'p'} color={ColorFgSubtle}>
        &mdash;
    </P2>
);
